var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app-table" },
    [
      !_vm.hideTitle
        ? _c("div", [
            _vm.selected.length || _vm.tableTitle
              ? _c("div", { staticClass: "table-title" }, [
                  _c("div", { staticClass: "title-wrapper" }, [
                    _vm.tableTitle
                      ? _c("div", { staticClass: "title" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.tableTitle) +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selected.length && _vm.counterText
                      ? _c("div", { staticClass: "counter" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.select.length) +
                              " " +
                              _vm._s(_vm.counterText) +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _vm.selected.length && _vm.showTableBtnHeader
                    ? _c(
                        "span",
                        {
                          staticClass: "selected-text",
                          on: { click: _vm.onDelete },
                        },
                        [
                          _vm._v(
                            "\n        " + _vm._s(_vm.selectedText) + "\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-data-table",
        _vm._b(
          {
            class: _vm.getClass,
            attrs: {
              "item-key": _vm.itemKey,
              items: _vm.loading ? [] : _vm.items,
              loading: _vm.loading,
              headers: _vm.headersFiltered,
              "select-all": _vm.selectAllCheckBox,
              "total-items": _vm.nativePagination ? undefined : 0,
              pagination: _vm.paginationSync,
              "rows-per-page-items": [_vm.rowsPerPageItems],
              "no-data-text": _vm.loading
                ? "Carregando"
                : "Nenhum resultado encontrado",
              flat: "",
              "hide-actions": "",
              "disable-initial-sort": "",
            },
            on: {
              "update:pagination": function ($event) {
                _vm.paginationSync = $event
              },
              input: _vm.toggleSelect,
            },
            scopedSlots: _vm._u([
              {
                key: "headerCell",
                fn: function (props) {
                  return [
                    props.header.tooltip && !props.header.tooltipIcon
                      ? _c("v-tooltip", { attrs: { top: "" } }, [
                          _c(
                            "span",
                            {
                              staticClass: "table-header-text",
                              attrs: { slot: "activator" },
                              slot: "activator",
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(props.header.text) +
                                  "\n        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(props.header.tooltip))]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !props.header.tooltip || props.header.tooltipIcon
                      ? _c("span", {
                          staticClass: "table-header-text",
                          domProps: { innerHTML: _vm._s(props.header.text) },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    props.header.tooltipIcon
                      ? _c(
                          "v-tooltip",
                          { attrs: { top: "" } },
                          [
                            _c(
                              "v-icon",
                              {
                                attrs: { slot: "activator", small: "" },
                                slot: "activator",
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(props.header.tooltipIcon) +
                                    "\n        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(props.header.tooltip),
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                },
              },
              {
                key: "items",
                fn: function (props) {
                  return [
                    !_vm.loading
                      ? _c(
                          "tr",
                          {
                            key: props.item._id,
                            class: _vm.getRowClass(props.item),
                          },
                          [
                            _vm.checkboxTable
                              ? _c(
                                  "td",
                                  [
                                    !props.item.disabled
                                      ? _c("v-checkbox", {
                                          attrs: {
                                            "input-value": props.selected,
                                            value: true,
                                            "value-comparator": () =>
                                              !!props.selected,
                                            primary: "",
                                            "hide-details": "",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.selectPropsIfCan(
                                                $event,
                                                props
                                              )
                                            },
                                          },
                                          model: {
                                            value: props.selected,
                                            callback: function ($$v) {
                                              _vm.$set(props, "selected", $$v)
                                            },
                                            expression: "props.selected",
                                          },
                                        })
                                      : _c("span", {
                                          staticClass: "checkbox-disabled",
                                        }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(
                              _vm.headers.filter((header) =>
                                typeof header.show === "boolean"
                                  ? header.show
                                  : true
                              ),
                              function (header, index) {
                                return _c(
                                  "td",
                                  {
                                    key: index,
                                    staticClass: "text-xs-left",
                                    class: _vm.getTableDataStyle(header, props),
                                    on: {
                                      click: function ($event) {
                                        return _vm.onAction(header, props.item)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "td-icon" },
                                      [
                                        header.icon
                                          ? _c(
                                              "v-icon",
                                              {
                                                class: _vm.iconClasses(
                                                  header,
                                                  props
                                                ),
                                                style: _vm.styleCombo,
                                                attrs: { slot: "activator" },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.onActionIcon(
                                                      header,
                                                      props.item
                                                    )
                                                  },
                                                },
                                                slot: "activator",
                                              },
                                              [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(
                                                      header.icon(props.item)
                                                        .type
                                                    ) +
                                                    "\n            "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.isOption(header) &&
                                        !!header.formatter &&
                                        !header.inputWithNoDataBind
                                          ? _c(
                                              "v-tooltip",
                                              { attrs: { bottom: "" } },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "activator" },
                                                  [
                                                    header.vHtml
                                                      ? _c("span", {
                                                          style:
                                                            _vm.getWidth(
                                                              header
                                                            ),
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              header.formatter(
                                                                props.item
                                                              )
                                                            ),
                                                          },
                                                        })
                                                      : _c(
                                                          "span",
                                                          {
                                                            style:
                                                              _vm.getWidth(
                                                                header
                                                              ),
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                  " +
                                                                _vm._s(
                                                                  header.formatter(
                                                                    props.item
                                                                  )
                                                                ) +
                                                                "\n                "
                                                            ),
                                                          ]
                                                        ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      header.formatter(
                                                        props.item
                                                      )
                                                    ),
                                                  },
                                                }),
                                              ],
                                              2
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    header.progress
                                      ? _c("v-progress-linear", {
                                          attrs: {
                                            value: header.progress(props.item),
                                            "background-color": "#E0E0E0",
                                            color: "#299D8D",
                                          },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    header.toggle
                                      ? _c(
                                          "div",
                                          [
                                            _c("v-switch", {
                                              staticClass: "table-toggle",
                                              attrs: { color: "secondary" },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.$emit(
                                                    "onToggle",
                                                    props.item
                                                  )
                                                },
                                              },
                                              model: {
                                                value: props.item[header.value],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    props.item,
                                                    header.value,
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "props.item[header.value]",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    header.button
                                      ? _c("div", [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "table-button",
                                              attrs: {
                                                color: "primary",
                                                flat: "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.$emit(
                                                    "onClick",
                                                    props.item
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(
                                                    header.buttonText(
                                                      props.item
                                                    ) || header.buttonText
                                                  ) +
                                                  "\n            "
                                              ),
                                            ]
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    header.input
                                      ? _c("div", [
                                          header.inputWithNoDataBind
                                            ? _c(
                                                "div",
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      type: header.type
                                                        ? header.type
                                                        : "text",
                                                      value:
                                                        props.item[
                                                          header.value
                                                        ],
                                                    },
                                                    on: {
                                                      input: (event) =>
                                                        _vm.onInputTableChange(
                                                          event,
                                                          props.item,
                                                          header
                                                        ),
                                                    },
                                                    model: {
                                                      value:
                                                        props.item[
                                                          header.value
                                                        ],
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          props.item,
                                                          header.value,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "props.item[header.value]",
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _c(
                                                "div",
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      type: header.type
                                                        ? header.type
                                                        : "text",
                                                      min: "1",
                                                    },
                                                    model: {
                                                      value:
                                                        props.item[
                                                          header.value
                                                        ],
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          props.item,
                                                          header.value,
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "props.item[header.value]",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.hasOption(header, props.item)
                                      ? _c(
                                          "v-menu",
                                          {
                                            attrs: {
                                              disabled: _vm.disableOptionsMenu(
                                                header,
                                                props.item
                                              ),
                                              origin: "center center",
                                              transition: "scale-transition",
                                              bottom: "",
                                              left: "",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  slot: "activator",
                                                  id: "btn-more-vert-app-table",
                                                  dark: "",
                                                  icon: "",
                                                },
                                                slot: "activator",
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  { staticClass: "more-icon" },
                                                  [
                                                    _vm._v(
                                                      "\n                more_vert\n              "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-list",
                                              _vm._l(
                                                header
                                                  .options(props.item)
                                                  .filter(
                                                    (option) =>
                                                      option.show ===
                                                        undefined || option.show
                                                  ),
                                                function (option, i) {
                                                  return _c(
                                                    "v-list-tile",
                                                    {
                                                      key: i,
                                                      attrs: {
                                                        disabled:
                                                          option.disabled,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.emit(
                                                            option.method,
                                                            props.item,
                                                            props.index
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-tile-title",
                                                        {
                                                          attrs: {
                                                            id: option.id,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                  " +
                                                              _vm._s(
                                                                option.title
                                                              ) +
                                                              "\n                "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              }
                            ),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.select,
              callback: function ($$v) {
                _vm.select = $$v
              },
              expression: "select",
            },
          },
          "v-data-table",
          _vm.$attrs["custom-sort"]
            ? { "custom-sort": _vm.$attrs["custom-sort"] }
            : {},
          false
        )
      ),
      _vm._v(" "),
      _vm.nativePagination && _vm.items.length > _vm.rowsPerPageItems
        ? _c(
            "div",
            { staticClass: "text-xs-center pt-2" },
            [
              _c("v-pagination", {
                attrs: { length: _vm.nativePages },
                on: { input: _vm.nativeInput },
                model: {
                  value: _vm.nativeCurrentPagination.page,
                  callback: function ($$v) {
                    _vm.$set(_vm.nativeCurrentPagination, "page", $$v)
                  },
                  expression: "nativeCurrentPagination.page",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }